//COLORS
export const colorDark = '#03334e';
export const colorLight = '#fff';
//LAYOUT
export const headerHeight = '100px';
export const headerMobileHeight = '50px';
export const footerHeight = '330px';
//DEVICES
export const tablet = '959px';
export const phone = '639px'

//CONTENT
export const navigation = {
  left: [
    {name: 'DinoSound', anchor: 'dinosound'},
    {name: 'Tausendsassa', anchor: 'tausendsassa'},
    {name: 'Aha Design', anchor: 'ahadesign'},
  ],
  right: [
    {name: 'Label Sitter', anchor: 'labelsitter'},
    {name: 'System.B', anchor: 'system.b'},
    {name: 'Saxophon Retreat', anchor: 'saxophonretreat'},
    {name: 'Handtuchverleih', anchor: 'handtuchverleih'},
  ]
};

export const mailTo = 'mailto:aline@lofds.de';

export const intro = {
  title: ['Lustige', 'Organisation', 'für dolle Sachen'],
  text: 'L.O.F.D.S. ein Familienunternehmen welches Organisation, Kreativität und Schönheit vereint. In unserem Team können innovative Ideen wachsen und unsere Business Center unterstützen sich gegenseitig, Expertise wird geteilt und dem Schaffensgeist sind keine Grenzen gesetzt. Ob Eventplanung, Design, Mode, Musik oder Equipmentverleih LOFDS zeichnet sich durch seine Vielfältigkeit aus und wird dadurch einzigartig. Obwohl Ideen meist klein beginnen, kann durch den Zusammenschluss unserer Business Center bereits ein Funke zu etwas Großem werden. Spaß, Kreativität und Begeisterung zeichnen unsere Arbeit aus, eben eine lustige Organisation für dolle Sachen.',
  button: {text: 'Schreib uns', link: mailTo}
};

export const elements = [
  {title: 'Tausendsassa', title_2: 'Entertainment', text: 'Umfasst die Studiotätigkeiten des Produzenten und Musikers Florin Kerber. In seinem selbstgebauten Tonstudio im Herzen Berlins produziert er vornehmlich handgemachte Musik.', linkText: 'Mehr über Tausendsassa Entertainment', linkAnchor: 'https://www.tausendsassa-entertainment.de/'},
  {title: 'Labelsitter', text: 'im Süden Münchens präsentieren wir seit über 20 Jahren, jede Saison einzigartige Modelabels. Wir stehen für Nachhaltigkeit und Transparenz… und der festen Überzeugung, dass alle einen Beitrag leisten können.', linkText: "Hier geht's zu den Labels", linkAnchor: 'https://www.Sorgenfri-sylt.de'},
  {title: 'System.B', text: 'Hier dreht sich alles um Events und Gastronomie. Wir vermitteln dir kompetentes Personal für alle Gastronomiebereiche, organisieren dein Event und auf Wunsch bringen wir Struktur in deine Bar oder dein Lager.', linkText: 'Mehr über System.B', linkAnchor: ''},
  {title: 'DinoSound', text: 'Ist eine Berliner Rockband mit eigenem Anspruch an große Songs. Gänzlich unbeeindruckt von Trends setzen die vier Freunde auf das, was sie lieben: handgemachte Rockmusik mit Hymnencharakter.', linkText: 'Mehr über DinoSound', linkAnchor: 'http://www.dinosound-music.com'},
  {title: 'Aha-Design', text: 'Der Fokus liegt hier auf der Gestaltung. Sei es das Erscheinungsbild deiner Marke, das Design des Web Auftritts oder die Umsetzung kreativer Details wie Illustration oder Animationen. Jede Design Aufgabe wird begeistert umgesetzt.', linkText: "Hier geht's zu Aha-Design", linkAnchor: ''},
  {title: 'Saxophon Retreat', text: 'Retreat, englisch für Rückzug, bezeichnet eine geplant spirituelle Ruhepause oder Rückzug von der gewohnten Umgebung… wir nutzen spirituelle Praktiken um den Irrglauben der „nicht Musikalität“ zu lösen.', linkText: 'Erfahre mehr über unsere Mission', linkAnchor: ''},
  {title: 'Handtuchverleih', text: 'Du möchtest Handtücher mieten und suchst ein Handtuchservice für deine Anlässe? Wir verleihen Geschirr-, Hand- und Badehandtücher für dein Event in und um Berlin.', linkText: 'Anfragen an tausendsassa@lofds.de', linkAnchor: 'tausendsassa@lofds.de'},
];

export const project = {
  title: ['Unsere', 'gemeinsamen', 'Projekte'],
  name: 'Sankas Spices',
  description: 'Sankas Spices - hilf Familien aus Sri Lanka zu überleben indem du deine Gewürze local beziehst.',
  linkText: 'Erfahre mehr über unsere Mission',
  linkAnchor: 'http://sankas-spices.com/'
}
